var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index107.js.map
